import { FC } from 'react';
import { IRecording } from '../../appointments/recording/RecordingState';
import { Text } from '../../components/Text';
import { AIIcon } from '../../theme/Icons';

export type INotesListSummarizedByAIProps = {
    recording?: IRecording;
};

export const NotesListSummarizedByAI: FC<INotesListSummarizedByAIProps> = ({ recording }) => {
    const summary = recording?.summary;
    return summary && (
        <div style={{display: 'flex', alignItems: 'center', gap: 4, color: 'var(--ion-color-step-600, #666666)'}}>
            <Text>
                <div style={{fontSize: 14}}>AI Summary</div>
            </Text>
            <AIIcon color="primary" />
        </div>
    );
};
